import MobileHome from "./MobileHome.vue";

const mobileHomeCtrl = new Vue({
    el: '#mobile-home',
    components: {MobileHome}
});
